import { useAuth0 } from "@auth0/auth0-react";
import { useEffect, useState } from "react";

/**
 * Unified authentication hook using Auth0
 */
export function useAuth() {
  const auth0 = useAuth0();
  
  return {
    isAuthenticated: auth0.isAuthenticated,
    isLoading: auth0.isLoading,
    user: auth0.user,
    login: auth0.loginWithRedirect,
    logout: (options = {}) => {
      const returnTo = window._env_.REACT_APP_POST_LOGOUT_URL 
        ? `${window.location.origin}${window._env_.REACT_APP_POST_LOGOUT_URL}`
        : window.location.origin;
      
      auth0.logout({ 
        logoutParams: { returnTo },
        ...options 
      });
    },
    getAccessToken: auth0.getAccessTokenSilently,
    error: auth0.error,
    provider: 'auth0'
  };
}

/**
 * Unified access token hook
 * Works with Auth0 provider
 */
export function useAccessToken() {
  const { getAccessTokenSilently, isAuthenticated, isLoading } = useAuth0();
  const [accessToken, setAccessToken] = useState(null);

  useEffect(() => {
    const fetchToken = async () => {
      if (isAuthenticated && !isLoading) {
        try {
          const token = await getAccessTokenSilently();
          setAccessToken(token);
        } catch (error) {
          console.error('Error getting access token:', error);
          setAccessToken(null);
        }
      }
    };
    
    fetchToken();
  }, [getAccessTokenSilently, isAuthenticated, isLoading]);

  return accessToken;
}